class IconTextOption extends BaseOption {
    constructor(container) {
        super(container);

        if (!this.container || !this.container.length) return;
        console.log(this.container.find('.pc-option-pp-sides-value').length);
        if (this.container.find('.pc-option-pp-sides-value').length) {
            this.initPPSidesHandler();
        }
    }

    initPPSidesHandler() {
        this.container.on('click', '.pc-option-pp-sides-value', (e) => {
            const $value = $(e.currentTarget);
            const index = $value.data('index');
            
            const $select = this.container.find('select[name="attribute_pp_sides"]');
            
            if ($select.length) {
                $select.val(index).trigger('change');
            }
        });
    }
} 